module.exports = __webpack_public_path__ + "static/media/corporateStep2.1da819fa.svg";